import {Component} from '@angular/core';

/**
 * Фоновая заглушка с текстом, если на странице нет контентра,
 * например "Нет новых уведомлений" на странице уведомлений
 */
@Component({
    selector: 'app-empty-page-placeholder',
    template: '<ng-content></ng-content>',
    styleUrls: ['empty-page-placeholder.component.scss']
})
export class EmptyPagePlaceholderComponent {

}
